export default __webpack_public_path__ + "static/Creaza-637b031b631a6d0d5ff08735aff81009.png";